import React from "react";
import './RadioGroup.css';
import CheckBox from './CheckBox';

class RadioGroup extends React.Component {
    constructor(props) {
        super(props);
        this.itemToggled = this.itemToggled.bind(this);
        this.refs = [];
        this.state = {
            errorHidden: this.props.required ? false : true,
            name: this.props.name
        }

        this.props.listener(this.state.name, { error: true, root: this.props.root });
    }

    itemToggled(checked) {
        this.setState({ errorHidden: true }, () => {
            this.refs.forEach((item, index) => {
                if (checked === index) {
                    this.props.listener(this.state.name, { value: item.current.state.value, error: false, root: this.props.root });
                }
                item.current.onChanged(checked === index);
            });
        });
    }

    renderCheckBoxes() {
        let refs = [];
        let items = [];
        this.props.options.forEach((item, index) => {
            let ref = React.createRef();
            items.push(<CheckBox name={this.props.name} item={item} key={"id" + item.option} ref={ref} index={index} onToggle={this.itemToggled} />);
            refs.push(ref);
        });
        this.refs = refs;
        return items;
    }

    render() {
        return (
            <div className="RadioGroup" id={this.props.id}>
                <span className="RadioGroup-title">{this.props.label}</span>
                <div className="RadioGroup-items">
                    {this.renderCheckBoxes()}
                </div>
                {!this.state.errorHidden ?
                    <span className="RadioGroup-error">{this.props.error_msg}</span>
                    : ""}
            </div>
        );
    }
}

export default RadioGroup;